import { render, staticRenderFns } from "./VModalProlongationAuthor.vue?vue&type=template&id=1b60ddb0&"
import script from "./VModalProlongationAuthor.vue?vue&type=script&lang=ts&"
export * from "./VModalProlongationAuthor.vue?vue&type=script&lang=ts&"
import style0 from "./VModalProlongationAuthor.vue?vue&type=style&index=0&id=1b60ddb0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports